import {of} from 'rxjs';
import {ProviderService} from '../_services';
import {catchError, finalize, tap} from 'rxjs/operators';
import {BaseDataSource} from '@core/models/data-source/_base.datasource';
import {QueryParamsModel} from '@core/models/query-models/query-params.model';
import {QueryResultsModel} from '@core/models/query-models/query-results.model';

export class ProviderDataSource extends BaseDataSource {

    constructor(private providersService: ProviderService) {
        super();
    }

    loadProviders(
        queryParams: QueryParamsModel
    ) {
        this.loadingSubject.next(true);
        this.providersService.findProviders(queryParams).pipe(
            tap(res => {
                this.entitySubject.next(res.results);
                this.paginatorTotalSubject.next(res.total);
            }),
            catchError(err => of(new QueryResultsModel([], err))),
            finalize(() => this.loadingSubject.next(false))
        ).subscribe();
    }
}
